import { atom } from "jotai";

type Message = {
  text: string;
  type: "received" | "sent";
  time: string;
};

export const messagesInfo = atom<Message[]>([]);
